<template>
  <div>
    <div class="sidenav-container">
      <!-- Sidenav for settings -->
      <div class="sidenav">
        <SettingsLayout active="Settings"></SettingsLayout>
      </div>
      <!-- General settings content -->
      <div
        class="sidenave-main-content"
        style="padding:0 !important;margin-top:-6px;overflow-y:hidden"
      >
        <b-row class="px-3 border-bottom">
          <b-col cols="12" class="px-0">
            <h2
              class="custom-page-title mb-2 mt-1 px-4"
              style="position:relative;bottom:4px;"
            >General</h2>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block py-4"
          style="padding-left:17px !important;padding-right:17px !important;overflow-y: scroll;height: calc(100vh - 142px);overflow-x:hidden"
        >
          <!-- Validation for sales -->
          <b-form @submit.prevent="onSubmit">
            <div class="page">
              <!-- Validation Message -->
              <b-alert
                class="alert-transparent alert-danger"
                :show="error_show && this.errors.any()"
              >
                <button type="button" @click="error_show=!error_show" class="close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <p class="fw-semi-bold">Document Print Label should not exceed 100 characters.</p>
              </b-alert>
              <b-row>
                <b-col>
                  <p class="text-muted fw-semi-bold">Select the modules to display</p>
                  <b-form-checkbox
                    plain
                    class="mb-2"
                    v-model.trim="preferences.modules.AmcService"
                  >Product Bundle</b-form-checkbox>
                  <b-form-checkbox
                    plain
                    class="mb-2"
                    v-model.trim="preferences.modules.AmcContract"
                  >AMC Contract</b-form-checkbox>
                  <b-form-checkbox
                    plain
                    class="mb-2"
                    v-model.trim="preferences.modules.Sales"
                  >Quotation</b-form-checkbox>
                  <b-form-checkbox
                    plain
                    class="mb-2"
                    v-model.trim="preferences.modules.Credit"
                  >Credit Note</b-form-checkbox>
                  <b-form-checkbox
                    plain
                    class="mb-2"
                    v-model.trim="preferences.modules.RecurringInvoice"
                  >Recurring Invoice</b-form-checkbox>
                  <b-form-checkbox
                    plain
                    class="mb-2"
                    v-model.trim="preferences.modules.RetainerInvoice"
                  >Customer Deposit</b-form-checkbox>
                  <b-form-checkbox
                    plain
                    class="mb-2"
                    v-model.trim="preferences.modules.Payment"
                  >Payments Received</b-form-checkbox>
                  <b-form-checkbox
                    plain
                    class="mb-2"
                    v-model.trim="preferences.modules.CustomerAdvance"
                  >Customer Advance</b-form-checkbox>
                  <b-form-checkbox
                    class="mb-2"
                    plain
                    :true-value="1"
                    :false-value="0"
                    v-if="org_details.gst_type == 1"
                    v-model.trim="preferences.bill_of_supply"
                  >Bill of Supply</b-form-checkbox>
                </b-col>
              </b-row>
              <hr align="left" width="60%" />
              <b-row>
                <b-col>
                  <p class="text-muted fw-semi-bold">Select Tax rate type</p>
                  <b-form-radio-group
                    stacked
                    name="tax_type"
                    v-model.trim="preferences.tax_type_id"
                    :options="tax_rate_types"
                  />
                </b-col>
              </b-row>
              <hr align="left" width="60%" />
              <b-row>
                <b-col>
                  <p class="text-muted fw-semi-bold">Select Discount rate type</p>
                  <b-form-radio-group
                    stacked
                    name="discount_cat"
                    v-model.trim="preferences.discount_cat"
                    :options="discount_rate_types"
                  />
                </b-col>
              </b-row>
              <hr align="left" width="60%" />
              <b-row>
                <b-col>
                  <p
                    class="text-muted fw-semi-bold"
                  >Select any additional charges you'll like to add</p>
                  <b-form-checkbox
                    class="mb-2"
                    plain
                    :true-value="1"
                    :false-value="0"
                    v-model.trim="preferences.is_shipping_charge"
                  >Shipping Charges</b-form-checkbox>
                  <b-form-checkbox
                    plain
                    :true-value="1"
                    :false-value="0"
                    v-model.trim="preferences.is_adjustment"
                  >Adjustments</b-form-checkbox>
                </b-col>
              </b-row>
              <hr align="left" width="60%" />
              <!-- Document Print Copy labels -->
              <b-row>
                <b-col lg="8" xl="4" md="8" sm="12">
                  <p class="text-muted fw-semi-bold">Document Print Copy label</p>
                  <b-form-group
                    horizontal
                    :label-cols="4"
                    label="Default Print"
                    label-for="default_print"
                  >
                    <v-select
                      :clearable="false"
                      id="default-print"
                      name="default_print"
                      v-validate="'required'"
                      :options="copies"
                      v-model="preferences.default_print_preference"
                      index="id"
                      label="text"
                    />
                  </b-form-group>
                  <b-form-group horizontal :label-cols="4" label="One Copy" label-for="one_copy">
                    <b-input-group class="input-group-transparent">
                      <b-input-group-text class="bg-transparent" slot="append">
                        <div
                          class="abc-checkbox abc-checkbox-success abc-checkbox-circle print-copy-checkbox"
                          style="margin-right: -5px;"
                        >
                          <input
                            disabled
                            :checked="preferences.default_print_preference>=1"
                            type="checkbox"
                            id="check_one_copy"
                          />
                          <label for="check_one_copy"></label>
                        </div>
                      </b-input-group-text>
                      <b-form-input
                        style="border-right:none !important;border-radius: 0px !important;"
                        name="one_copy"
                        v-validate="'max:100'"
                        v-model="preferences.document_copy_label[1]"
                        :class="{'is-invalid':error_show&&errors.has('one_copy')}"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    horizontal
                    :label-cols="4"
                    label="Two Copies"
                    label-for="two_copies"
                  >
                    <b-input-group class="input-group-transparent">
                      <b-input-group-text class="bg-transparent" slot="append">
                        <div
                          class="abc-checkbox abc-checkbox-success abc-checkbox-circle print-copy-checkbox"
                          style="margin-right: -5px;"
                        >
                          <input
                            disabled
                            :checked="preferences.default_print_preference>=2"
                            type="checkbox"
                            id="check_two_copies"
                          />
                          <label for="check_two_copies"></label>
                        </div>
                      </b-input-group-text>
                      <b-form-input
                        style="border-right:none !important;border-radius: 0px !important;"
                        :class="{'is-invalid':error_show&&errors.has('two_copies')}"
                        name="two_copies"
                        v-validate="'max:100'"
                        v-model="preferences.document_copy_label[2]"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    horizontal
                    :label-cols="4"
                    label="Three Copies"
                    label-for="three_copies"
                  >
                    <b-input-group class="input-group-transparent">
                      <b-input-group-text class="bg-transparent" slot="append">
                        <div
                          class="abc-checkbox abc-checkbox-success abc-checkbox-circle print-copy-checkbox"
                          style="margin-right: -5px;"
                        >
                          <input
                            disabled
                            :checked="preferences.default_print_preference>=3"
                            type="checkbox"
                            id="check_three_copies"
                          />
                          <label for="check_three_copies"></label>
                        </div>
                      </b-input-group-text>
                      <b-form-input
                        style="border-right:none !important;border-radius: 0px !important;"
                        :class="{'is-invalid':error_show&&errors.has('three_copies')}"
                        name="three_copies"
                        v-validate="'max:100'"
                        v-model="preferences.document_copy_label[3]"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    horizontal
                    :label-cols="4"
                    label="Four Copies"
                    label-for="four_copies"
                  >
                    <b-input-group class="input-group-transparent">
                      <b-input-group-text class="bg-transparent" slot="append">
                        <div
                          class="abc-checkbox abc-checkbox-success abc-checkbox-circle print-copy-checkbox"
                          style="margin-right: -5px;"
                        >
                          <input
                            disabled
                            :checked="preferences.default_print_preference>=4"
                            type="checkbox"
                            id="check_four_copies"
                          />
                          <label for="check_four_copies"></label>
                        </div>
                      </b-input-group-text>
                      <b-form-input
                        style="border-right:none !important;border-radius: 0px !important;"
                        :class="{'is-invalid':error_show&&errors.has('four_copies')}"
                        name="four_copies"
                        v-validate="'max:100'"
                        v-model="preferences.document_copy_label[4]"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    horizontal
                    :label-cols="4"
                    label="Five Copies"
                    label-for="five_copies"
                  >
                    <b-input-group class="input-group-transparent">
                      <b-input-group-text class="bg-transparent" slot="append">
                        <!-- <i
                        v-if="preferences.default_print_preference>=5"
                        class="fa fa-check-circle"
                        style="font-size: 15px; color: green;"
                        />-->
                        <div
                          class="abc-checkbox abc-checkbox-success abc-checkbox-circle print-copy-checkbox"
                          style="margin-right: -5px;"
                        >
                          <input
                            disabled
                            :checked="preferences.default_print_preference>=5"
                            type="checkbox"
                            id="check_five_copies"
                          />
                          <label for="check_five_copies"></label>
                        </div>
                        <!-- <i v-else class="fa fa-times-circle" style="font-size: 15px; color: red;" /> -->
                      </b-input-group-text>
                      <b-form-input
                        style="border-right:none !important;border-radius: 0px !important;"
                        :class="{'is-invalid':error_show&&errors.has('five_copies')}"
                        name="five_copies"
                        v-validate="'max:100'"
                        v-model="preferences.document_copy_label[5]"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- footer block -->
            </div>
            <div class="footer sidenav-footer" style="box-shadow:0 -4px 5px -3px #ccc;">
              <div class="form-action" style="background:none !important;">
                <b-button
                  type="submit"
                  size="sm"
                  variant="primary"
                  class="btn-rounded mr-3"
                  :disabled="submitted"
                >
                  <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
import SettingsLayout from "@/components/Layout/SettingsLayout";
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import $ from "jquery";
import vSelect from "vue-select";
export default {
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: { vSelect, SettingsLayout },
  data() {
    return {
      index_value: "",
      error_show: false, // to show the error message
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      submitted: false,
      tax_rate_types: [
        {
          value: 1,
          text: "Tax Inclusive"
        },
        {
          value: 2,
          text: "Tax Exclusive"
        },
        {
          value: 3,
          text: "Tax Inclusive or Tax Exclusive"
        }
      ],
      discount_rate_types: [
        {
          value: 1,
          text: "Product Level Discount"
        },
        {
          value: 2,
          text: "At Transaction Level (Before Tax)"
        },
        {
          value: 3,
          text: "At Transaction Level (After Tax)"
        },
        {
          value: 4,
          text: "I don't give discounts"
        }
      ],
      copies: [
        {
          id: 1,
          text: "One Copy"
        },
        {
          id: 2,
          text: "Two Copies"
        },
        {
          id: 3,
          text: "Three Copies"
        },
        {
          id: 4,
          text: "Four Copies"
        },
        {
          id: 5,
          text: "Five Copies"
        }
      ]
    };
  },
  methods: {
    removeRoute() {
      var asyncroutes = this.permission_routes.children;
      $.each(asyncroutes, (key, value) => {
        if (
          value.meta.action == "index" &&
          value.meta.hasChildren == false &&
          typeof this.preferences.modules[value.name] != "undefined"
        ) {
          this.permission_routes.children[
            key
          ].meta.affix = this.preferences.modules[value.name];
        }
      });
    },
    async onSubmit() {
      // await this.removeRoute();
      this.$validator.validateAll().then(result => {
        if (result) {
          this.error_show = false;
          this.submitted = true;
          var data = {
            modules: {
              preferences: this.preferences
            }
          };
          this.$store.dispatch("settings/general", data).then(() => {
            this.removeRoute();

            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: "Preferences updated successfully",
              type: "success",
              showCloseButton: true
            });

            setTimeout(() => {
              this.submitted = false;
            }, 1000);
          });
        } else {
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch("settings/fetchinvoicesettings", { stg_menu: "General" })
      .then(() => {
        next();
      });
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      preferences: state => state.settings.list["General"].preferences,
      permission_routes: state => state.permission.routes,
      list: state => state.settings.list
    }),
    ...mapGetters(["org_details"])
  }
};
</script>
<style scoped>
.bg-transparent {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.form-check-inline {
  display: block !important;
}
</style>
